import { render, staticRenderFns } from "./Customs.vue?vue&type=template&id=68cc1fed&scoped=true"
import script from "./Customs.vue?vue&type=script&lang=js"
export * from "./Customs.vue?vue&type=script&lang=js"
import style0 from "./Customs.vue?vue&type=style&index=0&id=68cc1fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc1fed",
  null
  
)

export default component.exports